<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/platform-user' }">后台用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
     <layout-panel :show-header="false"
                  class="table-panel">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane v-for="(platform, index) in platformlist" :key="index" :label="platform.name + '管理'" :name="platform.name">
    <layout-panel :show-header="false"
                  class="table-panel">
      <el-button type="primary"
                 size="mini"
                 @click="addRole">添加角色
      </el-button>
    </layout-panel>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row>
        <el-table-column prop="id"
                         label="序号"></el-table-column>

        <el-table-column prop="name"
                         label="角色名"></el-table-column>

        <el-table-column prop="comment"
                         label="备注"></el-table-column>

        <el-table-column prop="updated_at"
                         label="更新时间"></el-table-column>

        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="onEdit(scope.row.id)">修改
            </el-button>

            <el-button type="text"
                       size="mini"
                       @click="onCopy(scope.row.id)">复制
            </el-button>

            <el-button type="text"
                       size="mini"
                       @click="onDelete(scope.row.id)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

      </el-tab-pane>
    </el-tabs>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'



export default {
  mixins: [table],



  data () {
    return {
      activeName: '',
      platformlist: [],
      currentPlatform: null,
      activeIndex: 0,
      uiRole: {
        name: 'UI权限',
        host: ''
      }
    }
  },



  computed: {
    onUiRole () {
      return this.currentPlatform && this.currentPlatform.name === this.uiRole.name
    }
  },



  created () {
    let savedPlatform = localStorage.getItem('platform')
    if (savedPlatform) {
      this.currentPlatform = JSON.parse(savedPlatform)
    }
    this.fetchPlatformlist().then(data => {
      this.activeName = this.currentPlatform.name
    })
  },



  methods: {
    ...Vuex.mapActions(['getRolesIndex', 'deleteRole']),

    getTableData (params) {
      const apiName = this.onUiRole ? 'getUiRolesIndex' : 'getRolesIndex'
      if (this.currentPlatform) {
        params.host = this.currentPlatform.host
      }
      return request.page(apiName, params)
    },

    onEdit (roleId) {
      const name = this.onUiRole ? '编辑UI权限角色' : '编辑后台用户角色'
      this.$router.push({name, params: {roleId}})
    },
    onCopy (id) {
      const apiName = this.onUiRole ? 'copyUiRole' : 'copyRole'
      request.common(apiName, {host: this.currentPlatform.host, id}).then((res) => {
        this.onRefresh()
      })
    },

    fetchPlatformlist () {
      return request.common('getPermissionPlatformlist', {}).then(({data}) => {
        if (!localStorage.getItem('platform')) {
          this.currentPlatform = data.main
          localStorage.platform = JSON.stringify(this.currentPlatform)
        }
        this.platformlist.push(data.main)
        this.platformlist.push(...data.others)
        this.platformlist.push(this.uiRole)
        return data.main
      })
    },

    handleClick (tab, event) {
      this.activeIndex = tab.index
      const platform = this.platformlist[tab.index]
      this.currentPlatform = platform
      localStorage.platform = JSON.stringify(this.currentPlatform)
      this.onRefresh()
    },
    addRole () {
      this.onUiRole
        ? this.$router.push({name: '新增UI权限角色'})
        : this.$router.push({name: '新增后台用户角色'})
    },
    onDelete (id) {
      this.$confirm('确认删除此角色?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const apiName = this.onUiRole ? 'deleteUiRole' : 'deleteRole'
        request.common(apiName, {host: this.currentPlatform.host, id}).then((res) => {
          this.onRefresh()

          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
  },
}
</script>


<style lang="scss"
       scoped
       src="../../platform-user/style/PlatformUser.scss"></style>



// WEBPACK FOOTER //
// src/views/platform-role/pages/PlatformRoleTable.vue